<template>
  <div class="wrapper">
    <slot :triggered="triggered" />
  </div>
</template>

<script>
export default {
  props: ['type', 'entryTitle'],
  methods: {
    triggered () {
      if (typeof window.topNavStore !== 'undefined') {
        window.topNavStore.commit('setSearchType', this.type)
        window.topNavStore.commit('setFormData', {
          key: 'entry',
          value: {
            title: this.entryTitle
          }
        })

        $(document).trigger('open-search-input')
      }
    }
  }
}
</script>

<style scoped>
.wrapper {
  display: contents;
}
</style>